module.exports = "<div class=\"postagem\">\n  <video width=\"100%\" controls controlsList=\"nodownload\" *ngIf=\"type === 'file'\" style=\"background: #000000\">\n    <source [src]=\"videoLink\" />\n  </video>\n  <iframe width=\"560\" height=\"315\" [src]=\"videoLink\" frameborder=\"0\"  *ngIf=\"type !== 'file'\" allowfullscreen></iframe>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/feed/embed/embed.component.html
// module id = ./src/app/shared/feed/embed/embed.component.html
// module chunks = main